<template>
<div class="integral">
  <div class="bg-pic" :style="'background-image:url('+img.integral_bg+')'">
    <div class="f-r f-14 f-w pd-15" @click="getIntegral">获取路径</div>
    <div class="infobox">
      <div class="f-14 f-w c-coler">当前积分</div>
      <div class="f-30 f-w c-coler">10000</div>
      <div class="f-12">积分使用说明：</div>
      <div class="f-12">积分可以兑换雷克萨斯稀有物品，可以兑换各种活动入场券。</div>
    </div>
  </div>
  <div class="tools-list">
    <div class="tools-items text-c">
      <div class="f-14 f-w">积分明细</div>
      <div class="f-12 c-gray">(积分数据记录每3个月清空一次)</div>
      <van-list class="intebox" v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="false" @load="onLoad">
        <van-cell-group>
          <van-cell title-class="text-l" title="升级" value="+10" label="2019-10-12" />
        </van-cell-group>
      </van-list>
    </div>
  </div>
  <van-popup
  v-model="show"
  closeable
  round
  position="bottom"
  :style="{ height: '22%' }"
  >
    <div class="f-14 f-w pd-10">获取途径</div>
    <div class="f-12 pd-5">1、用户等级升级会有积分奖励</div>
    <div class="f-12 pd-5">2、日常使用APP过程的奖励</div>
    <div class="f-12 pd-5">3、每月前1000名可以领取积分奖励(100-999)</div>
  </van-popup>
</div>
</template>

<script>
import {List,Cell,CellGroup,Popup} from 'vant'
export default {
  data () {
    return {
      show:false,
      list: [],
      loading: false,
      finished: false,
      img:{
          integral_bg: require('../../../assets/img/member/integral_bg.png'),
      }
    }
  },
  created () {
    this.$store.commit('param/show', false)
    let source = this.$store.state.param.source
    if(source == 3||source == 7) {
      this.$appService.isShowReturn({state: true})
    }
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    getIntegral(){
      this.show=true
    },
    close(){
      this.show=false
    },
    onLoad() {

    }
  },
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]:CellGroup,
    [Popup.name]:Popup
  }
}
</script>

<style lang="scss">
.integral{

  .bg-pic {
    width: 100%;
    height: 100%;
    background-size: 100% 220px;
    background-repeat: no-repeat;
    background-position: center;
  }
  .pd-15{
    padding: 15px;
  }
  .infobox{
    padding: 50px 15px; 

    .c-coler{
      color: #694900;
    }
  }
  .tools-list {
    margin-top: -30px;
    padding-left: 15px;
    padding-right: 15px;
    position: relative;
  }
  .tools-items {
    padding: 10px 10px;
    background: #fff;
    border-radius: 5px;
    box-shadow: 1px 0 2px 0 #dedad9, 1px 3px 5px 0 #dad4d3;

    .intebox{
      margin-top: 20px;
    }
  }
  .pd-10{
    padding: 10px;
  }
  .pd-5{
    padding: 5px;
  }
}
</style>
